import { Container } from '@mui/material';
import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { ThemeContext } from '../../../contexts/theme-context';
import { projectsData } from '../../../data/projectsData';
import './projects.css';

function Projects() {
  const { theme } = useContext(ThemeContext);

  return (
    <div style={{ backgroundColor: theme.secondary }}>
      <Container className='projects' id='projects'>
        <h1 style={{ color: theme.primary }}>Featured Projects</h1>
        <p style={{ color: theme.tertiary }} className='projects-subtitle'>
          Product-focused case studies: problem, system design, stack, and measurable outcome.
        </p>

        <div className='projects-grid'>
          {projectsData.map((project) => (
            <article
              key={project.id}
              className='project-card'
              style={{ background: theme.quaternary }}
            >
              <h2 style={{ color: theme.primary }}>{project.title}</h2>

              <div className='project-block'>
                <h3 style={{ color: theme.tertiary }}>Problem</h3>
                <p style={{ color: theme.tertiary }}>{project.problem}</p>
              </div>

              <div className='project-block'>
                <h3 style={{ color: theme.tertiary }}>Solution</h3>
                <p style={{ color: theme.tertiary }}>{project.solution}</p>
              </div>

              <div className='project-block'>
                <h3 style={{ color: theme.tertiary }}>Tech</h3>
                <div className='project-tags'>
                  {project.tech.map((tag) => (
                    <span
                      key={`${project.id}-${tag}`}
                      style={{ borderColor: theme.primary, color: theme.primary }}
                    >
                      {tag}
                    </span>
                  ))}
                </div>
              </div>

              <div className='project-block'>
                <h3 style={{ color: theme.tertiary }}>Impact</h3>
                <p style={{ color: theme.tertiary }}>{project.impact}</p>
              </div>

              {project.link && (
                <Link
                  className='project-link'
                  to={project.link}
                  style={{ color: theme.primary, borderColor: theme.primary }}
                >
                  View MS-G030 Wiki
                </Link>
              )}
            </article>
          ))}
        </div>
      </Container>
    </div>
  );
}

export default Projects;
